export const firebaseConfig = {
  apiKey: "AIzaSyDdlwoo9qsSpzZyRS60Hrvgu9IGcxYohFA",
  authDomain: "lab.motekawa.photo",
  databaseURL: "https://motelab-212cd.firebaseio.com/",
  storageBucket: 'gs://motelab',
  projectId: "motelab",
  messagingSenderId: ""
};



// WEBPACK FOOTER //
// ./src/lib/firebase/config.js